<template>
  <div>
    <v-layout row wrap="">
      <v-flex>
        <h2 class="title">{{ thread.thread.subject }}</h2>
      </v-flex>
      <v-flex style="text-align: right;">
        <v-btn flat @click="removeparti">Konversation löschen</v-btn>
      </v-flex>
    </v-layout>
    <v-card
      flat
      class="my-3 grey lighten-4"
      v-for="message in this.thread.messages"
      :key="message.id"
    >
      <v-card-text class="subheading pb-0 mb-0">
        <nl2br tag="p" :text="message.body"/>
      </v-card-text>
      <v-card-text class="">
        <timeago :datetime="message.created_at" :auto-update="60"></timeago>
        von
        {{ message.user.name }}
      </v-card-text>
    </v-card>
    <v-layout row wrap="">
      <v-flex xs10>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-textarea
            v-model="message"
            box
            clearable
            label="Ihre Nachricht"
            type="text"
            auto-grow
            validate-on-blur
            :rules="NachrichttextRules"
          ></v-textarea>
        </v-form>
      </v-flex>
      <v-flex  xs12 sm3>
        <v-btn large color="accent" @click="nachrichtSenden">Senden
          <v-icon right>send</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  props: ['thread'],

  data () {
    return {
      betriebcheckloading: true,
      message: '',
      valid: false,
      NachrichttextRules: [
        v => !!v || 'Bitte Nachricht eingeben',
        v =>
          (v && v.length <= 1000) ||
          'Bitte nicht mehr als 1000 Buchstaben verwenden.'
      ]
    }
  },
  computed: {
    ThreadLaenge () {
      return this.thread.messages.length
    }
  },
  mounted: function () {},
  methods: {
    nachrichtSenden () {
      if (this.$refs.form.validate()) {
        this.loading = true

        const daten = {
          thread_id: this.thread.thread.id,
          message: this.message
        }

        axios
          .put('/api/v1/nachrichten/' + this.thread.thread.id, daten)
          .then(resp => {
            // console.log(resp)

            this.fehlertext = ''

            this.$store.dispatch('responseMessage', {
              type: 'success',
              text: 'Nachricht gesendet!'
            })

            this.message = ''
            this.$emit('nachrichtgesendet')
            // this.block = true
          })
          .catch(resp => {
            console.log('error..')
            // console.log('error: ')
            //   console.log(resp);
          })

        this.loading = false
      }
    },

    removeparti () {
      const daten = {
        id: this.thread.thread.id
      }

      axios
        .post('/api/v1/removeparti', daten)
        .then(resp => {
          // console.log(resp)

          this.$store.dispatch('responseMessage', {
            type: 'success',
            modal: false,
            text: 'Konversation ausgeblendet'
          })

          this.thread.thread = []

          this.$emit('threadgeloescht')
          // this.block = true
        })
        .catch(resp => {
          console.log('error..')
          // console.log('error: ')
          console.log(resp)
        })

      this.$store.dispatch('fetchNachrichten')
    }
  }
}
</script>

<style>
</style>